import api from './api';

export const usuarioService = {
  getLicencas
};

function getLicencas(id_usuario) {
  return api.get(`${process.env.VUE_APP_ROOT_API}/usuarios/${id_usuario}/licencas`);
}